import axios, { AxiosRequestConfig } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import config from '~/config';
import { errorInterceptor, requestInterceptor, responseInterceptor, refreshAuthLogic } from './axios/interceptors';

export const Unauthorized = 401;

const options: AxiosRequestConfig = {
  baseURL: `${config.apiUrl}`,
  withCredentials: true,
};

const axiosBase = axios.create(options);

axiosBase.interceptors.request.use(requestInterceptor);
axiosBase.interceptors.response.use(responseInterceptor, errorInterceptor);

// Setup auth refresh interceptor
createAuthRefreshInterceptor(axiosBase, refreshAuthLogic);

export default axiosBase;
